import { observer } from 'mobx-react-lite'
import { QuestionStepViewModel } from '@/features/jobs/drafting/IntakeQuestionsViewModel'
import { type DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { StepContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/Step/StepContainer'
import { renderStepContent } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/render-step-content'
import { JobCreationQuestions } from '@/features/jobs/drafting/components/CreateJobDialog/JobCreationQuestions'

export interface JobCreationQuestionsContainerProps {
  vm: DraftJobViewModel
  jobWasCreated: boolean
  isValidationShown: boolean
}

export const JobCreationQuestionsContainer = observer(
  function JobCreationQuestionsContainer({
    vm,
    jobWasCreated,
    isValidationShown,
  }: JobCreationQuestionsContainerProps) {
    const steps = vm.stepAccessors.map((stepAccessor) => {
      const stepContent = renderStepContent(stepAccessor, {
        isLegendDisabled: jobWasCreated,
        isValidationShown,
      })
      if (!stepContent) {
        return null
      }

      return (
        <StepContainer
          key={stepAccessor.step.stepId}
          stepAccessor={stepAccessor}
          isNotValid={
            isValidationShown &&
            stepAccessor instanceof QuestionStepViewModel &&
            stepAccessor.isIncomplete
          }
          compact
        >
          {stepContent}
        </StepContainer>
      )
    })

    return (
      <JobCreationQuestions isLoading={vm.isBusy}>{steps}</JobCreationQuestions>
    )
  },
)
